import React, { useState, useRef, useEffect } from 'react';
import MainMenu from './menu/MainMenu.js';
import Header from './menu/Header.js';
import { isMobile } from './helpers/HelperFunctions.js';
import { ScrollContext, menuTypes } from '../constants.js';

const MainContent = (props) => {
    const [scrollData, setScrollData] = useState({
        scrollTop: 0,
        scrollHeight: 0,
        clientHeight: 0,
    });
    const scrollRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
                setScrollData({ scrollTop, scrollHeight, clientHeight });
            }
        };

        const scrollElement = scrollRef.current;
        scrollElement.addEventListener("scroll", handleScroll);

        return () => scrollElement.removeEventListener("scroll", handleScroll);
    }, []);

    return <div className="main-content" ref={scrollRef}>
        <ScrollContext.Provider value={scrollData}>
            {(!props.hideHeaderForMobile || !isMobile()) && <Header key="header" />}
            {props.children}
            <MainMenu menuType={menuTypes.main} />
        </ScrollContext.Provider>
    </div>
}

export default MainContent;



